
import { prop, Vue } from "vue-class-component";
import {
  checkRolePermission
} from "@/app/infrastructures/misc/Utils";
import formatDate from "@/app/infrastructures/misc/common-library/v2/FormatDate";
import { PusatResolusiListData } from "@/domain/entities/PusatResolusi";
import { FlagsPermissionPusatResolusi } from "@/feature-flags/flags-pusat-resolusi";
import { statusData } from "./modules";
import { dataLayer } from "@/app/infrastructures/misc/UtilsGtm";

class Props {
  data = prop<PusatResolusiListData>({
    default: new PusatResolusiListData(),
    type: Object
  });
}

export default class PusatResolusiCard extends Vue.with(Props) {
  // permission
  get ableToViewDetail() {
    return FlagsPermissionPusatResolusi.permission_pusat_resolusi_v1_detail.isEnabled();
  }

  formatDate(date: string): string {
    return formatDate(date);
  }

  get statusData() {
    return statusData(this.data.rcStatus);
  }

  toDetail() {
    dataLayer("pusat_resolusi_lihat_detail", {}, [
      "timestamp",
      "userType",
      "userId"
    ]);
    this.$router.push(`/pusat-resolusi/detail?params=${this.data.rcTicketNoGenesis}`);
  }
}
